import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-678 (1.1 purpose).
export const PurposeScreen = () => (
  <StubScreen id="purpose" heading="Wofür wollen Sie den Kredit nutzen?" />
);
